/* eslint-disable no-debugger */
import './CustomerSatisfaction.module.css';
import Textarea from '../../../inputs/Textarea';
import ActionIntraPageButton from '../../../buttons/ActionIntraPageButton';
import useCustomerSatisfaction from './UseCustomerSatisfaction';
import style from './CustomerSatisfaction.module.css';

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

const DEFAULT_COUNT = 5;
const DEFAULT_ICON = "😊";

const ICON1 = "😠";
const ICON2 = "😞";
const ICON3 = "😐";
const ICON4 = "🙂";
const ICON5 = "😄";

const DEFAULT_COLOR = "#FFD700";
const DEFAULT_UNSELECTED_COLOR = "grey";

//NOTE: use <br/> to create line breaks in the help text
const CustomerSatisfaction = ({ count, icon, color, iconSize, dataKeyName, dataKeyValue, customerSatisfactionId, helpText = 'Please rate your experience using our software and / or working with our Team Services personnel.' }) => {
  const {
    uIState,
    rating,
    setRating,
    temporaryRating,
    setTemporaryRating,
    comments,
    setComments,
    stars,
    handleClick
  } = useCustomerSatisfaction(count, dataKeyName, dataKeyValue, customerSatisfactionId);

  return (
    <div style={{ paddingLeft: '20px', paddingBottom: '10px', backgroundColor: 'white', border: '1px solid lightgray', borderRadius: '8px', width: '335px' }}>
      <p style={{ paddingTop: '10px', paddingBottom: '2px', paddingRight: '20px', paddingLeft: '20px', fontSize: '24px', color: 'charcoal' }}>
        Member Satisfaction
      </p>
      <p style={{ lineHeight: '1.2', paddingBottom: '5px', paddingLeft: '20px', paddingRight: '24px', fontSize: '14px', color: '#041e42' }}>
        {
          typeof helpText === 'string'
            ? helpText.split('<br/>').map((line, idx) => (
              <span key={idx}>
                {line}
                <br /><br />
              </span>
            ))
            : helpText
        }
      </p>
      {uIState.surveyComplete ?
        <p style={{ paddingLeft: '38px', paddingBottom: '20px', fontSize: '16px', color: '#041e42' }}>
          Thank you for your feedback!
        </p>
        :
        <div>
          <div className='starsContainer' style={{ display: 'flex', paddingLeft: '12px' }} >
            {stars.map((item, index) => {
              const isActiveColor =
                (rating || temporaryRating) &&
                (index < rating || index < temporaryRating);

              let elementColor = "";
              if (isActiveColor) {
                elementColor = color || DEFAULT_COLOR;
              } else {
                elementColor = DEFAULT_UNSELECTED_COLOR;
              }

              return (
                <div
                  className='star'
                  key={index}
                  style={{
                    fontSize: iconSize ? `${iconSize}px` : '24px',
                    color: elementColor,
                    filter: `${isActiveColor ? "grayscale(0%)" : "grayscale(100%)"}`
                  }}
                  onMouseOver={() => setTemporaryRating(index + 1)}
                  onMouseLeave={() => setTemporaryRating(0)}
                  onClick={() => setRating(index + 1)}
                >
                  {/* {icon ? icon : DEFAULT_ICON} */}
                  {(() => {
                    switch (index) {
                      case 0:
                        return ICON1;
                        // return <FontAwesomeIcon icon={faChevronDown} />;
                      case 1:
                        return ICON2;
                        // return <FontAwesomeIcon icon={faChevronDown} />;
                      case 2:
                        return ICON3;
                      case 3:
                        return ICON4;
                      case 4:
                        return ICON5;
                      default:
                        return DEFAULT_ICON;
                    }
                  })()}
                </div>

              );
            })}
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', paddingLeft: '12px', paddingRight: '24px', paddingTop: '14px' }}>
            <span style={{ textAlign: 'left' }}>Not Satisfied</span>
            <span style={{ textAlign: 'right' }}>Very Satisfied</span>
          </div>
          <div style={{ marginTop: '20px', paddingLeft: '20px' }}>
            <Textarea
              className={style.Textarea}
              name="comments"
              value={comments}
              placeholderValue='Optional comment'
              onChange={(value) => setComments(value)} />
          </div>
          <div style={{ marginTop: '10px', paddingBottom: '10px', paddingLeft: '20px' }}>
            <ActionIntraPageButton width="100%" onClick={() => { handleClick() }}>Save Your Feedback</ActionIntraPageButton>
          </div>
        </div>
      }
    </div>
  );
};

export default CustomerSatisfaction;